import React, { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Loading, TextArea } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface Props {
	terminateElement: (reason: string) => void | Promise<void>;
	isOpen: boolean;
	setIsOpen?: Dispatch<SetStateAction<boolean>>;
	title: string;
	content: string | JSX.Element;
}

const TerminateDialog = ({
	terminateElement,
	isOpen,
	setIsOpen,
	title,
	content,
}: Props) => {
	const { t } = useTranslation();

	const history = useHistory();

	const [deleteLoading, setDeleteLoading] = useState(false);
	const [reason, setReason] = useState("");

	const handleTextChange = (
		event: React.ChangeEvent<HTMLTextAreaElement>
	) => {
		const reason = event.target.value;
		setReason(reason);
	};

	const handleClose = () => (setIsOpen ? setIsOpen(false) : history.goBack());

	return isOpen ? (
		<Modal
			className="activity-instance__terminate-dialog"
			close={handleClose}
			isOpen={isOpen}
			title={title}
			modalSize="md"
			showHeaderClose
			footer={
				<div>
					<Button
						label={t("common.labels.cancel")}
						className="btn-default"
						onClick={handleClose}
					/>
					<Button
						label={!deleteLoading && t("common.labels.terminate")}
						className="btn-primary"
						disabled={!reason || !reason.trim()}
						onClick={async () => {
							setDeleteLoading(true);
							await terminateElement(reason);
							setDeleteLoading(false);
							handleClose();
						}}>
						{deleteLoading && <Loading />}
					</Button>
				</div>
			}>
			{typeof content === "string" ? <p>{content}</p> : content}
			<TextArea
				onChange={handleTextChange}
				label={t("main.activityInstances.text.terminateReason")}
				required
				id={t("formDesigner.labels.formId")}
			/>
		</Modal>
	) : null;
};

export default TerminateDialog;
